
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import  themen  from 'theme/styles/styled-colors';
import  * as theme  from 'react-syntax-highlighter/dist/esm/styles/hljs';
import SyntaxHighlighter from 'react-syntax-highlighter';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "entity-attribute-option-softreference"
    }}>{`Entity Attribute Option: SoftReference`}</h1>
    <h4 {...{
      "id": "background"
    }}>{`Background`}</h4>
    <p>{`Entity attributes are specified using attribute definitions. An attributes' persistence strategy is determined by based on their type.`}</p>
    <p>{`Primitive types are persisted as properties within the vertex of their parent.`}</p>
    <p>{`Non-primitive attributes get a vertex of their own and edge is created between the parent the child to establish ownership.`}</p>
    <p>{`Attribute with `}<em parentName="p">{`isSoftReference`}</em>{` option set to `}<em parentName="p">{`true`}</em>{`, is non-primitive attribute that gets treatment of a primitive attribute.`}</p>
    <h4 {...{
      "id": "specification"
    }}>{`Specification`}</h4>
    <p>{`Below is an example of using the new attribute option.`}</p>
    <SyntaxHighlighter wrapLines={true} language="json" style={theme.dark} mdxType="SyntaxHighlighter">
  {`"attributeDefs": [
      {
        "name": "replicatedFrom",
        "typeName": "array<AtlasServer>",
        "cardinality": "SET",
        "isIndexable": false,
        "isOptional": true,
        "isUnique": false,
        "options": {
          "isSoftReference": "true"
        }
      },...]`}
    </SyntaxHighlighter>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;